import * as React from 'react';
import { hydrate } from 'react-dom';
import { ErrorLogComponent } from '@cian/error-log-component';
import { TDevice } from '@cian/utils';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { getLogger } from '@cian/logger/browser';
import { getConfig } from '@cian/config/browser';

import { CookieAgreementContainer } from '../../../shared/containers/CookieAgreementContainer';

export function initializeCookieAgreement() {
  const container = document.getElementById('cookie-agreement');
  if (!container) {
    return;
  }

  const config = getConfig();
  const isAdaptive = config.get<boolean>('isAdaptive') || false;
  const initialDeviceType = config.get<TDevice>('initialDeviceType') as TDevice;

  hydrate(
    <ErrorLogComponent logger={getLogger()}>
      <UiKitContextProvider deviceType={initialDeviceType}>
        <CookieAgreementContainer isAdaptive={isAdaptive} />
      </UiKitContextProvider>
    </ErrorLogComponent>,
    container,
  );
}
